import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export function excludeGeneralOptions<T extends ISelectOption>(options: T[]) {
  return options.reduce((optionsData: T[], status) => {
    if (!optionsData.find(item => item.label === status.label)) {
      optionsData.push(status);
    }

    return optionsData;
  }, []);
}
